import React from 'react';

import { useTranslation } from 'react-i18next';

export const NotFound = () => {
  const { t } = useTranslation('containerInterface');
  return (
    <div className="flex h-full items-center justify-center pb-20 text-2xl leading-tight font-medium text-gray-500">
      {t('text404NotFound')}
    </div>
  );
};
